export const ADDRESSES = {
  VOTING: "0xD9d785b11d2ED9E487971DF9FA2B89b7B99C614D",
  FUNDRAISER: "0xdb1Bc2A7C2e6CBc112138E098132761e301b510c",
  REWARD: "0x62f8846e2c342Db3bFeBaf520c13D05f2FD1f177",
  MEMBERSHIP: "0x964aC0C570C3DB72100Dd99e11dB244761aA20bf",
};
